<template>
    <dash icon="fa fa-money" titulo="RENDIMENTOS ANUAIS (DIRFs)" @click.native="$router.push(rota)"></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
	props: {
		rota: {
			type: Object,
			default: () => ({
				name: 'FornecedorDirfs'
			})
		}
	},

	components: {
		Dash
	},

	data() {
		return {}
	}
}
</script>
